import { http } from "../../common/helpers/index";
import { baseUrl } from "../../common/config";
import { ASSIGNED, COMPLETED } from "../consts/assignedContentStatus";
import { MAX_32_SAFE_NUMBER } from "../../shared/consts/max32SafeNumber";

export const getToWatchAssignedContents = ({ ...params }) => {
  return http.get(
    `${baseUrl}/api/financial-wellness/participants/assigned-contents`,
    {
      params: {
        ...params,
        statusId: ASSIGNED,
      },
    }
  );
};

export const getWatchedAssignedContents = ({ ...params }) => {
  return http.get(
    `${baseUrl}/api/financial-wellness/participants/assigned-contents`,
    {
      params: {
        ...params,
        statusId: COMPLETED,
      },
    }
  );
};

export const getAssignedContent = ({ ...params }) => {
  return http.get(
    `${baseUrl}/api/financial-wellness/participants/assigned-contents`,
    {
      params: {
        ...params,
      },
    }
  );
};

export const getAssignedContentById = (assignedContentId) =>
  http.get(
    `${baseUrl}/api/financial-wellness/participants/assigned-contents/${assignedContentId}`
  );

export const getContentById = (contentId) =>
  http.get(`${baseUrl}/api/contents/${contentId}`);

export const getAllContent = () => http.get(`${baseUrl}/api/contents/`);

export const getCategoryById = (categoryId) =>
  http.get(`${baseUrl}/api/categories/${categoryId}`);

export const assignParticipantContent = ({
  participantProfileId,
  contentIds,
}) => {
  return http.post(
    `${baseUrl}/api/financial-wellness/participants/assign-contents`,
    { contentIds, participantProfileId }
  );
};

export const markParticipantContentAsWatched = (watchedContentId) => {
  return http.post(
    `${baseUrl}/api/financial-wellness/participants/watched-content`,
    null,
    {
      params: {
        watchedContentId,
      },
    }
  );
};

export const getResourceTypes = () => {
  return http.get(`${baseUrl}/api/resources/resource-types`);
};

export const getAllAvailableContent = ({ ...params }) => {
  return http.get(`${baseUrl}/api/contents`, {
    params,
  });
};

export const getAllMyAssignedContent = (
  sortOrder,
  orderBy,
  pageNumber,
  pageSize,
  statusId
) => {
  return http.get(
    `${baseUrl}/api/financial-wellness/participants/assigned-contents?pageSize=${
      pageSize || MAX_32_SAFE_NUMBER
    }&sortOrder=${sortOrder || ""}&orderBy=${orderBy || ""}&pageNumber=${
      pageNumber || ""
    }&statusId=${statusId || ""}`
  );
};

export const getRelatedContent = (contentId) => {
  return http.get(`${baseUrl}/api/contents/related-content/${contentId}`);
};

export const bookmarkContent = (contentId) => {
  return http.post(
    `${baseUrl}/api/financial-wellness/participants/bookmark-content/${contentId}`
  );
};

export const getBookmarkedContents = ({ ...params }) => {
  return http.get(
    `${baseUrl}/api/financial-wellness/participants/all-content`,
    {
      params: {
        ...params,
        statusId: ASSIGNED,
      },
    }
  );
};
